import { render, staticRenderFns } from "./FundBankingData.vue?vue&type=template&id=33c6d22e&scoped=true"
import script from "./FundBankingData.vue?vue&type=script&lang=js"
export * from "./FundBankingData.vue?vue&type=script&lang=js"
import style0 from "./FundBankingData.vue?vue&type=style&index=0&id=33c6d22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c6d22e",
  null
  
)

export default component.exports